// 시그니쳐 : 25레벨, 임팩트 : 18레벨, 5성 골글 : 25레벨, 4성 골글 : 23레벨
import PlayerCard from './../components/PlayerCard';
// 국가대표 : 20레벨, 올스타 : 25레벨, 
// 5성 라이브 : 25레벨, 4성 라이브 : 23레벨, 3성 라이브 : 21레벨, 2성 라이브 : 19레벨, 1성 라이브 : 17레벨
// 5성 시즌 : 20레벨, 4성 시즌 : 18레벨, 3성 시즌 : 16레벨

const maxTrainStates25Batter = {level: 25, s1:18, s2:17, s3:12, s4:10, s5:9 ,s6:9} // 75
const maxTrainStates23Batter = {level: 23, s1:17, s2:16, s3:11, s4:9, s5:8 ,s6:8} // 69
const maxTrainStates21Batter = {level: 21, s1:16, s2:15, s3:10, s4:8, s5:7 ,s6:7} // 63
const maxTrainStates20Batter = {level: 20, s1:14, s2:14, s3:10, s4:8, s5:7 ,s6:7} // 60
const maxTrainStates19Batter = {level: 19, s1:14, s2:14, s3:9, s4:7, s5:7 ,s6:6} // 57
const maxTrainStates18Batter = {level: 18, s1:13, s2:13, s3:8, s4:7, s5:7 ,s6:6} // 54
const maxTrainStates17Batter = {level: 17, s1:13, s2:13, s3:8, s4:6, s5:6 ,s6:5} // 51
const maxTrainStates16Batter = {level: 16, s1:13, s2:13, s3:7, s4:5, s5:5 ,s6:5} // 48

const maxTrainStates25Pitcher = {level: 25, s1:12, s2:18, s3:17, s4:10, s5:9 ,s6:9} // 75
const maxTrainStates23Pitcher = {level: 23, s1:11, s2:17, s3:16, s4:9, s5:8 ,s6:8} // 69
const maxTrainStates21Pitcher = {level: 21, s1:10, s2:16, s3:15, s4:8, s5:7 ,s6:7} // 63
const maxTrainStates20Pitcher = {level: 20, s1:10, s2:14, s3:14, s4:8, s5:7 ,s6:7} // 60
const maxTrainStates19Pitcher = {level: 19, s1:9, s2:14, s3:14, s4:7, s5:7 ,s6:6} // 57
const maxTrainStates18Pitcher = {level: 18, s1:8, s2:13, s3:13, s4:7, s5:7 ,s6:6} // 54
const maxTrainStates17Pitcher = {level: 17, s1:8, s2:13, s3:13, s4:6, s5:6 ,s6:5} // 51
const maxTrainStates16Pitcher = {level: 16, s1:7, s2:13, s3:13, s4:5, s5:5 ,s6:5} // 48
const maxTrainStates0 = {level: 0, s1:0, s2:0, s3:0, s4:0, s5:0, s6:0}

const maxTrainStatesBatterMap = {
    25 : maxTrainStates25Batter,
    23 : maxTrainStates23Batter,
    21 : maxTrainStates21Batter,
    20 : maxTrainStates20Batter,
    19 : maxTrainStates19Batter,
    18 : maxTrainStates18Batter,
    17 : maxTrainStates17Batter,
    16 : maxTrainStates16Batter,
    0  : maxTrainStates0
}

const maxTrainStatesPitcherMap = {
    25 : maxTrainStates25Pitcher,
    23 : maxTrainStates23Pitcher,
    21 : maxTrainStates21Pitcher,
    20 : maxTrainStates20Pitcher,
    19 : maxTrainStates19Pitcher,
    18 : maxTrainStates18Pitcher,
    17 : maxTrainStates17Pitcher,
    16 : maxTrainStates16Pitcher,
    0  : maxTrainStates0
}

export function calculateMaxTrainLevel(player) {

    if (!player) {
        return 0;
    } else if (player.type === '시그니쳐') {
        return 25;
    } else if (player.type === '임팩트') {
        return 18;
    } else if (player.type === '골든글러브') {
        return player.stars === 5 ? 25 : 23;
    } else if (player.type === '국가대표') {
        return 20;
    } else if (player.type === '올스타') {
        return 25;
    } else if (player.type === '라이브') {
        switch (player.stars) {
            case 5: return 25;
            case 4: return 23;
            case 3: return 21;
            case 2: return 19;
            case 1: return 17;
            default: return 0;
        }
    } else if (player.type === '시즌') {
        switch (player.stars) {
            case 5: return 20;
            case 4: return 18;
            case 3: return 16;
            default: return 0;
        }
    } else {
        return 0;
    }
}

export function getMaxTrainStates(player) {
    const maxLevel = calculateMaxTrainLevel(player);
    const isPitcher = player.isPitcher;

    if (isPitcher) {
        return maxTrainStatesPitcherMap[maxLevel] || maxTrainStates0;
    } 

    return maxTrainStatesBatterMap[maxLevel] || maxTrainStates0;
}

// 시즌, 임팩트, 시그니쳐, 골든글러브 = 최대 3레벨
// 국가대표 = 최대 4레벨 
export function calculateMaxSpecialTrainLevel(player) {
    if (!player) {
        return 0;
    } else if(player.isFa) {
        return 5;
    } else if (['시즌', '임팩트', '시그니쳐', '골든글러브'].includes(player.type)) {
        return 3;
    } else if (player.type === '국가대표') {
        return 4;
    } else {
        return 0;
    }
}

